import React, { useEffect } from 'react';
import Icon from '../AppIcon';

const Toast = ({ message, type = 'info', onClose, duration = 3000 }) => {
    useEffect(() => {
        if (duration > 0) {
            const timer = setTimeout(onClose, duration);
            return () => clearTimeout(timer);
        }
    }, [duration, onClose]);

    const styles = {
        success: 'bg-green-500',
        error: 'bg-red-500',
        warning: 'bg-yellow-500',
        info: 'bg-blue-500'
    };

    const icons = {
        success: 'CheckCircle',
        error: 'XCircle',
        warning: 'AlertTriangle',
        info: 'Info'
    };

    return (
        <div className={`${styles[type]} text-white px-6 py-4 rounded-lg shadow-lg flex items-center space-x-3 animate-slide-in-right`}>
            <Icon name={icons[type]} className="w-5 h-5" />
            <span className="flex-1">{message}</span>
            <button onClick={onClose} className="hover:opacity-80 transition-opacity">
                <Icon name="X" className="w-4 h-4" />
            </button>
        </div>
    );
};

export default Toast;
